import React from 'react';
import classnames from 'classnames';
import Typography from 'components/uiLibrary/Typography';
import classes from './SectionHeader.module.scss';

const SectionHeader = ({ title, className }) => (
  <div className={classnames(classes.sectionHeader, className)}>
    <div className={classes.line}></div>
    <Typography weight="bold" color="primary" size={12} textTransform="uppercase">
      {title}
    </Typography>
    <div className={classes.line}></div>
  </div>
);

export default SectionHeader;
